import React from 'react';
import './ExamSetupContainer.css';

/**
 * ExamSetupContainer - A container component for the simulate exam setup area
 * This provides a consistent, themed container with light/dark mode support
 */
const ExamSetupContainer = ({ children, title = "Simulate Exam" }) => {
  return (
  <div className="simulate-exam" style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      flex: 1,
      boxSizing: 'border-box'
    }}>
      <div className="exam-setup-wrapper">
        <div className="exam-setup-header">
      <h1 className="exam-setup-main-title">{title}</h1>
        </div>
        
        <div className="exam-setup-container" style={{ margin: '0 auto' }}>
          <div className="exam-setup-content">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExamSetupContainer;
